import { Injectable } from "@angular/core"
import { FireStoreService } from "@services/fire-store.service"
import { arrayUnion } from "@angular/fire/firestore"
import { SubVersionDTO } from "@services/sub-section.service"

export interface LogsDTO {
  dates: Array<string>
  programs: Array<string>
  id: string
  // [key: string]: Array<{ date: string; message: string }>
}

@Injectable({
  providedIn: "root",
})
export class LogsService extends FireStoreService<LogsDTO> {
  constructor() {
    super()
    this.init({
      collectionKey: `logs`,
      fullTextFields: [],
    })
  }

  getMyPrograms(uuid: string): Promise<Array<string>> {
    return this.firestore
      .collection(this.config.collectionKey)
      .doc(uuid)
      .get()
      .toPromise()
      .then((res: any) => {
        const data = res.data && res.data()
        return data.programs
      })
      .catch((err) => this.handleError(err, null))
  }

  sendLog(uuid: string, programId: string, message: string): Promise<SubVersionDTO> {
    const log = {
      message,
      date: new Date(),
    }
    const dateKey = new Date().toISOString().split("T")[0]

    return this.firestore
      .collection(this.config.collectionKey)
      .doc(uuid)
      .set(
        { ["logs-" + programId]: arrayUnion(log), programs: arrayUnion(programId), dates: arrayUnion(dateKey) },
        { merge: true }
      )
      .catch((err) => this.handleError(err, ""))
  }
}
